import React, { useEffect } from "react";
import { Button, Form, Input, message, Typography, Card, Flex } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { openNotification } from "../../../Components/Notification";
import { useLoader } from "../../../Context/LoaderContext";
import teamMemberService from "../../../Service/team-member.service";
import "./index.scss";

const TeamMemberSignUp: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { setLoadingMessage, setLoading } = useLoader();

  useEffect(() => {
    if (!token) {
      navigate("/404");
    }
  }, [token]);

  const handleSignUp = async (formValues: any) => {
    try {
      setLoading(true);
      setLoadingMessage("Signing up please wait...");
      const data = { ...formValues };
      if (token) {
        data.token = token;
      }
      delete data.confirm;
      const response = await teamMemberService.teamMemberSignUp(data);
      if (response) {
        if (response?.data?.statusCode === 400) {
          openNotification("error", response.message, "");
          return;
        } else if (response.status === 201) {
          openNotification("success", response?.data, "Sign in to continue");
          navigate("/sign-in");
        }
      }
    } catch (err) {
      console.error("Unable to create account:", err);
      message.error("Unable to create your account. Please try again.");
    } finally {
      setLoading(false);
      setLoadingMessage(null);
    }
  };

  return (
    <Flex align="center" justify="center" className="sign-up-container">
      <Card
        style={{ maxWidth: 360, width: "100%" }}
        bordered
        className="card"
        title={
          <Typography.Title level={4} style={{ margin: 0 }}>
            Team Member Signup
          </Typography.Title>
        }
      >
        <Form
          name="team_member_signup"
          initialValues={{ remember: true }}
          onFinish={handleSignUp}
          autoComplete="true"
          scrollToFirstError
          className="team-member-signup-form"
        >
          <Form.Item
            name="firstName"
            rules={[{ required: true, message: "Please enter your first name!" }]}
          >
            <Input placeholder="First name" />
          </Form.Item>
          <Form.Item
            name="lastName"
            // rules={[{ required: true, message: "Please enter your last name!" }]}
          >
            <Input placeholder="Last name" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Please enter your password!",
              },
            ]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>
          <Form.Item
            name="confirm"
            dependencies={["password"]}
            rules={[
              {
                required: true,
                message: "Please confirm your password!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("The new password that you entered do not match!")
                  );
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm Password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Sign Up
            </Button>
          </Form.Item>
          <Typography.Paragraph style={{ textAlign: "center" }}>
            Already have an account?
            <span className="login-text">
              <a onClick={() => navigate("/sign-in")}>Sign In</a>
            </span>
          </Typography.Paragraph>
        </Form>
      </Card>
    </Flex>
  );
};

export default TeamMemberSignUp;
